import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    CartItems : []
  },
  getters: {
    getCartItems : state => state.CartItems,
  },
  mutations: {
    AddCartItems(state,payload){
      let isInCart = state.CartItems.find(v=>v.id === payload.id)
      if(isInCart){
        isInCart.qty++
      }else{
        return state.CartItems.push(payload)
      }

    },
    removeQty(state,index){
      if(state.CartItems[index].qty <= 0){
        state.CartItems[index].qty = 0
      }else{
        state.CartItems[index].qty--
      }

    },
    addQty(state,index){
      return state.CartItems[index].qty++
    },
    removeCart(state,payload){
      return state.CartItems.splice(payload)
    }
  },
  plugins: [
    createPersistedState({
      key : "Cart"
    }),
  ],
  actions: {
  },
  modules: {
  }
})
